import { Modal, ModalBody, ModalDescription, ModalFooter, ModalHeader, ModalTitle } from "@/ds/custom/Modal";
import { Button } from "@/ds/shadcn/components/ui/button";
import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { ErrorDisplay } from "@/lib/common/ErrorDisplay";
import type { ProblemResponse } from "@/lib/http";
import { type FC } from "react";

export interface ModalConfirmProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	title: string;
	description: string;
	isLoading?: boolean;
	error?: ProblemResponse | null;
	confirmText?: string;
	confirmDestructive?: boolean;
	cancelText?: string;
}

export const ModalConfirm: FC<ModalConfirmProps> = props => {
	const {
		open,
		onOpenChange,
		onConfirm,
		title,
		description,
		isLoading = false,
		error,
		confirmText = "Confirm",
		confirmDestructive = false,
		cancelText = "Cancel"
	} = props;

	return (
		<Modal open={open} onOpenChange={onOpenChange} preventCloseOnInteractOutside={isLoading}>
			<ModalHeader>
				<ModalTitle>{title}</ModalTitle>
				<ModalDescription>{description}</ModalDescription>
			</ModalHeader>
			{
				error && (
					<ModalBody>
						<ErrorDisplay error={error} />
					</ModalBody>
				)
			}
			<ModalFooter>
				<Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
					{cancelText}
				</Button>
				<Button variant={confirmDestructive ? "destructive" : "default"} onClick={onConfirm} disabled={isLoading}>
					{isLoading ? <Spinner /> : <>{confirmText}</>}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
